import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './Select.module.scss';

const Select = (props) => {
    const [value, setValue] = React.useState(
        props.default ? props.items.findIndex((i) => (i.value || i.id) === props.default) : 0
    );

    const selectError = props.error?.find(e => e.variants?.find(v => v.id === props.id));

    const change = (e) => {
        setValue(e.target.value);
        props.change(props.items[e.target.value]);
    };

    return (
        <>
        <select
            className={styles['select-component']}
            onChange={change}
            value={value}
            id={props.id}
        >
            {(props.items || []).map((item, idx) => (
                <option
                    disabled={item.disabled}
                    defaultValue={item.defaultValue}
                    key={item.value || item.id}
                    value={idx}
                >
                    {item.name}
                </option>
            ))}
        </select>
        {selectError ? <span><I18n>product_page.sizing.select_a_size</I18n></span> : null}
        </>
    );
};

Select.propTypes = {
    change: PropTypes.func,
    default: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    items: PropTypes.arrayOf(
        PropTypes.object
    ),
    id: PropTypes.string,
    error: PropTypes.array,
};

export default Select;
